import React from "react";
import {
  makeRequestAuth,
  setGlobalCookie,
  getCookieToken,
} from "../../utils/globals";

import { withRouter } from "react-router-dom";
import { number, string } from "prop-types";
import ProfileService from "../../services/profileService";
import { getUserBalance } from "../../global/getUserBalance";
var downloadTimer;
//callback for add fund
class PaypalPaymentCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order_id: string,
      company_recharge: number,
      status: this.props.match.params.id,
      redirectPath: string,
      sales_order_id: string,
      timeOutReachedForPolling: false,
    };
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidMount() {
    setTimeout(() => {
      const response = this.props.history.location.state
        ? JSON.parse(this.props.history.location.state)
        : "";
      this.setState(
        {
          redirectPath: response && response.callbackUrl,
          order_id: response && response.order_id,
          origin: response && response.origin,
          status: response && response.status,
          sales_order_id: response && response.sales_order_id,
          amount: response && response.amount,
          company_recharge: response && response.company_recharge,
        },
        () => this.paymentUpdate()
      );
    }, 2000);
  }

  plumProPoints = () => {
    const { updatePlumProPoints } = this.props;

    ProfileService.plumProPoints({})
      .then((response) => {
        if (
          response &&
          response.cashReserveBalance &&
          response.cashReserveBalance.status == true
        ) {
          let data = response.cashReserveBalance.data.balance;

          updatePlumProPoints(data);
        }
      })
      .catch(() => {});
  };
  triggerTimeoutForPolling() {
    this.myInterval = setInterval(() => {
      clearInterval(this.myInterval);
      this.setState({
        timeOutReachedForPolling: true,
      });
    }, 90000);
  }

  paymentUpdate = () => {
    let order_id = this.state.order_id;
    let order_id_encoded = btoa(order_id);
    let callbackPath = this.state.redirectPath; /// need to check this
    let origin = this.state.origin;
    const company_recharge = this.state.company_recharge;
    const rechargedAmount = sessionStorage.getItem("rechargeAmount") || 0;
    if (this.state.status == "success") {
      if (
        !getCookieToken("ADMIN_TRANSECTION_ID") ||
        getCookieToken("ADMIN_TRANSECTION_ID") !== order_id
      ) {
        // this.interval = setInterval(() => {
        this.triggerTimeoutForPolling();
        this.orderUpdate(order_id, origin, order_id_encoded, callbackPath);
        // }, 5000);
      }
    } else if (status == "failure") {
      this.props.history.push({
        pathname: "/admin/paypal-payment-status/fail/" + order_id_encoded,
        state: JSON.stringify({
          callbackPath: callbackPath,
          order_id,
          origin: origin,
          status: "fail",
          amount: rechargedAmount,
          rechargeFailReason: "transaction failure",
          company_recharge: company_recharge,
        }),
      });
    } else if (status == "cancel") {
      this.props.history.push({
        pathname: "/admin/paypal-payment-status/cancel/" + order_id_encoded,
        state: JSON.stringify({
          callbackPath: callbackPath,
          order_id: order_id,
          origin: origin,
          status: "cancel",
          amount: rechargedAmount,
          company_recharge: company_recharge,
        }),
      });
    } else {
      this.props.history.push({
        pathname: "/admin/paypal-payment-status/fail/" + order_id_encoded,
        state: JSON.stringify({
          callbackPath: callbackPath,
          order_id: order_id,
          origin: origin,
          status: "fail",
          amount: rechargedAmount,
          rechargeFailReason: "transaction failure",
          company_recharge: company_recharge,
        }),
      });
    }
  };

  orderUpdate = (order_id, origin, order_id_encoded, callbackPath) => {
    const { updateUserBalance } = this.props;
    const rechargedAmount = sessionStorage.getItem("rechargeAmount") || 0;
    const company_recharge = this.state.company_recharge;
    this.getOrderstatusByPollingApi(this.state.sales_order_id)
      .then((response) => {
        if (
          response !== undefined &&
          response.data.rechargeOrderStatus &&
          response.data.rechargeOrderStatus.error == false
        ) {
          if (response.data.rechargeOrderStatus.data.order_status_id == 1) {
            if (this.state.timeOutReachedForPolling) {
              clearInterval(this.interval);
              this.props.history.push({
                pathname:
                  "/admin/paypal-payment-status/pending/" + order_id_encoded,
                state: JSON.stringify({
                  callbackPath: callbackPath,
                  order_id: order_id,
                  origin: origin,
                  status: "pending",
                  amount: rechargedAmount,
                  company_recharge: company_recharge,
                }),
              });
            } else {
              this.orderUpdate(
                order_id,
                origin,
                order_id_encoded,
                callbackPath
              );
            }
          } else if (
            response.data.rechargeOrderStatus.data.order_status_id == 4
          ) {
            clearInterval(this.interval);
            this.props.history.push({
              pathname:
                "/admin/paypal-payment-status/pending/" + order_id_encoded,
              state: JSON.stringify({
                callbackPath: callbackPath,
                order_id: order_id,
                origin: origin,
                status: "pending",
                amount: rechargedAmount,
                company_recharge: company_recharge,
              }),
            });
          } else if (
            response.data.rechargeOrderStatus.data.order_status_id == 5
          ) {
            clearInterval(this.interval);
            this.props.history.push({
              pathname: "/admin/paypal-payment-status/fail/" + order_id_encoded,
              state: JSON.stringify({
                callbackPath: callbackPath,
                order_id: order_id,
                origin: origin,
                status: "fail",
                amount: rechargedAmount,
                rechargeFailReason: "transaction failure",
                company_recharge: company_recharge,
              }),
            });
          } else {
            clearInterval(this.interval);
            getUserBalance(updateUserBalance);
            if (origin == "plumPro") {
              this.plumProPoints();
            }
            var timeleft = 10;
            downloadTimer = setInterval(
              function () {
                timeleft--;
                this.setState({ timer: timeleft });

                if (timeleft <= 0) {
                  clearInterval(downloadTimer);
                  setGlobalCookie("ADMIN_TRANSECTION_ID", order_id);
                  this.props.history.push({
                    pathname:
                      "/admin/paypal-payment-status/success/" +
                      order_id_encoded,
                    state: JSON.stringify({
                      callbackPath: callbackPath,
                      order_id: order_id,
                      origin: origin,
                      status: "success",
                      order_status_id:
                        response.data.rechargeOrderStatus.data.order_status_id,
                      amount: rechargedAmount,
                      company_recharge: company_recharge,
                    }),
                  });
                }
              }.bind(this),
              1000
            );
          }
        } else {
          clearInterval(this.interval);
          this.props.history.push({
            pathname: "/admin/paypal-payment-status/fail/" + order_id_encoded,
            state: JSON.stringify({
              callbackPath: callbackPath,
              order_id: order_id,
              origin: origin,
              status: "fail",
              amount: rechargedAmount,
              rechargeFailReason: "transaction failure",
              company_recharge: company_recharge,
            }),
          });
        }
      })
      .catch((err) => {
        clearInterval(this.interval);
        console.log(err);
      })
      .then(() => {});
  };

  getOrderstatusByPollingApi = () => {
    return new Promise((resolve) => {
      const request = {
        query: "paypal.query.recharge_order_status",
        tag: "paypal",
        variables: {
          add_data: { order_id: this.state.sales_order_id },
        },
      };
      makeRequestAuth(request, (response) => {
        if (response && response.data) {
          resolve(response);
        } else {
          resolve(response);
        }
      });
    });
  };

  render() {
    return (
      <div
        className="col-md-12"
        style={{
          position: "relative",
          minHeight: "400px",
          textAlign: "center",
          marginTop: "30px",
        }}
      >
        <img
          src="/admin/img/loading.gif"
          width="30px"
          style={{ margin: "0px 0px 0px 20px" }}
        />
        <div style={{ marginTop: "1rem" }}>
          <h4>
            Please do not refresh the page and wait while we are processing your
            payment...
          </h4>
        </div>
      </div>
    );
  }
}

export default withRouter(PaypalPaymentCallback);
